import React from 'react';
import {Icon, IconButton, withStyles} from '@material-ui/core';
import {bindActionCreators} from 'redux';
import * as Actions from 'app/store/actions';
import connect from 'react-redux/es/connect/connect';
import classNames from 'classnames';

const styles = theme => ({
    Icon: {
        color: theme.palette.type === 'dark' ? '#fff' : '#616161'
    }
});

const NavbarMobileToggleButton = ({classes, navbarToggleMobile, children, className}) => {
    return (
        <IconButton className={classNames(classes.Icon, className)} onClick={navbarToggleMobile} disableRipple>
            {children}
        </IconButton>
    );
};

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        navbarToggleMobile: Actions.navbarToggleMobile
    }, dispatch);
}

export default withStyles(styles, {withTheme: true})(connect(null, mapDispatchToProps)(NavbarMobileToggleButton));
